const Revisor = {
  ExportAttachmentsActionButtonText: "Revisor.ExportAttachmentsActionButtonText",
  ExportAttachmentsDialogTitle: "Revisor.ExportAttachmentsDialogTitle",
  ExportAttachmentsDialogDescription: "Revisor.ExportAttachmentsDialogDescription",
  ExportAttachmentsDialogDescription2: "Revisor.ExportAttachmentsDialogDescription2",
  FinancialStatementAttachments: "Revisor.FinancialStatementAttachments",
  BalanceAccounts: "Revisor.BalanceAccounts",
  SIEFiles: "Revisor.SIEFiles",
  OtherDocuments: "Revisor.OtherDocuments",
  PeriodicVATReport: "Revisor.PeriodicVATReport",
  PeriodicSummaryOfEmployerContributions: "Revisor.PeriodicSummaryOfEmployerContributions",
  TaxAccountStatement: "Revisor.TaxAccountStatement",
  FinalTaxStatement: "Revisor.FinalTaxStatement",
  BankStatement: "Revisor.BankStatement",
  IncomeTaxReturn: "Revisor.IncomeTaxReturn",
  ExportsConfirmedMessage: "Revisor.ExportsConfirmedMessage",
  ExportedOvernight: "Revisor.ExportedOvernight",
  ExportedAsSoonAsPossible: "Revisor.ExportedAsSoonAsPossible",
  DownloadedDirectly: "Revisor.DownloadedDirectly",
  ExportAttachmentsFailed: "Revisor.ExportAttachmentsFailed",
  ExportFailedNoPermission: "Revisor.ExportFailedNoPermission",
  ExportFailedNoReconciliation: "Revisor.ExportFailedNoReconciliation",
  ExportConfirmationMessage: "Revisor.ExportConfirmationMessage",
  TaxCalculationReport: "Revisor.TaxCalculationReport",
  FinancialStatementSpecifications: "Revisor.FinancialStatementSpecifications",
  YearEndDocuments: "Revisor.YearEndDocuments",
  SharedFolderEmptyMessage: "Revisor.SharedFolderEmptyMessage",
  AuditorCaseTitle: "Revisor.AuditorCaseTitle",
  AuditorCaseNoCase: "Revisor.AuditorCaseNoCase",
  AuditorCaseAnswerLabel: "Revisor.AuditorCaseAnswerLabel",
  AuditorCaseUnread: "Revisor.AuditorCaseUnread",
  AuditorCaseSendFailed: "Revisor.AuditorCaseSendFailed",
  AuditorCaseDownload: "Revisor.AuditorCaseDownload",
  AuditorCaseDownloadFailed: "Revisor.AuditorCaseDownloadFailed",
  }
export default Revisor;